<template>
	<button
		type="button"
		class="g-block-pay-unlock__btn"
		:style="style"
		@click="$emit('click', $event)"
	>{{ text }}</button>
</template>

<script>
	export default {
		name: 'GPayUnlockButton',
		props: {
			text: {
				type: String,
				default: '解锁',
			},
			style: {
				type: Object,
				default: () => ({}),
			},
		},
		emits: ['click'],
	};
</script>
